import React, { Component } from 'react';
// import logo from 'assets/images/logo_top.png';
import queryString from 'query-string';
import Grid from '@material-ui/core/Grid';
// import Hidden from '@material-ui/core/Hidden';
// import IconMenu from '@material-ui/icons/Menu';
import { withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
// import Typography from '@material-ui/core/Typography';
// import { Link } from 'react-router-dom';
// import 'react-sticky-header/styles.css';
// import StickyHeader from 'react-sticky-header';
// import HeaderMenu from './HeaderMenu';
import HeaderLogin from './HeaderLogin';

const styles = (theme) => {
  return {
    root: {
      height: 400,
      background: 'linear-gradient(180deg, #fff 10%, #fbe4ec 100%)',
      position: 'relative',
      '& .MuiTypography-h1': {
        [theme.breakpoints.down('sm')]: {
          fontSize: '2rem',
          paddingBottom: 20,
        },
      },
    },
    logo: {
      backgroundImage: 'url(' + require('assets/images/logo_communication.png') + ')',
      backgroundSize: 'contain',
      backgroundPosition: '50% 100%',
      backgroundRepeat: 'no-repeat',
      width: 200,
      height: 61,
      margin: theme.spacing(2),
    },
    wave: {
      backgroundImage: 'url(' + require('assets/images/wave-page-top.svg') + ')',
      backgroundSize: 'contain',
      backgroundPosition: '50% 100%',
      backgroundRepeat: 'no-repeat',
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 9,
    },
    content: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 10,
    },
    headerLogin: {
      position: 'absolute',
      top: 10,
      right: 10,
      zIndex: 11,
    },
    headerTitle: {
      position: 'absolute',
      // top: 140,
      top: 36,
      width: '100%',
      textAlign: 'center',
    },
    headerRegular: {
      padding: theme.spacing(3),
      width: '100%',
      textAlign: 'center',
      '& .MuiTypography-h1': {
        fontSize: '2rem',
      },
    },
  };
};

class Header extends Component {
  render() {
    const { classes } = this.props;

    const { title } = this.props;
    // const menuSize = ['sm', 'xs'].indexOf(this.props.width) < 0 ? 40 : 28;
    const URI = queryString.parse(this.props.location.search);

    if (URI.print === 'true') {
      return (
        <div>
          <If condition={title !== undefined}>
            <Grid item container style={{ position: 'relative' }}>
              <div className={classes.headerRegular}>{title}</div>
            </Grid>
          </If>
        </div>
      );
    }
    return (
      <header className={classes.root}>
        <div className={classes.wave}></div>
        <div className={classes.content}>
          <Grid container>
            <div className={classes.logo}></div>
            <div className={classes.headerLogin}>
              <HeaderLogin />
            </div>
            <If condition={title !== undefined}>
              <Grid item container style={{ position: 'relative' }}>
                <div className={classes.headerTitle}>{title}</div>
              </Grid>
            </If>
          </Grid>
        </div>
      </header>
    );
  }
}

export default withRouter(withStyles(styles)(Header));



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx